module.exports = __webpack_public_path__ + "static/media/bird.0f815391.jpg";